<script setup>
// 组件已通过路由加载，不需要在这里导入
</script>

<template>
  <router-view />
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f7fa;
  overflow-x: hidden;
}

#app {
  height: 100vh;
  width: 100vw;
  overflow: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

/* 修复Element Plus的一些容器宽度问题 */
.el-container {
  width: 100%;
  height: 100%;
  max-width: 100vw;
}

.el-main {
  width: 100%;
  padding: 0;
  max-width: 100vw;
}

.el-aside {
  flex-shrink: 0;
}

/* 确保内容填满整个屏幕 */
.dashboard-container {
  width: 100vw;
  min-width: 100vw;
  max-width: 100vw;
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}

/* 修复Element Plus的行和列布局 */
.el-row {
  width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* 移除所有可能导致水平滚动的右边距 */
body, html, #app, .el-container, .el-main, .el-row, .el-col {
  overflow-x: hidden;
}
</style>
